import { Component, OnInit } from "@angular/core";
import { DashboardResponseDTO } from "../models/DashboardResponseDTO";
import { Observable, Subscription } from "rxjs";
import { DashboardService } from "../services/Dashboard.service";
import { SessionService } from "../../shared/services/Session.service";
import { AuthService } from "../../authmanagement/services/Auth.service";

@Component({
  selector: "app-dashboardPage",
  templateUrl: "./dashboardPage.component.html",
  styleUrls: ["./dashboardPage.component.css"],
})
export class DashboardPageComponent implements OnInit {
  isAdmin: boolean = false;
  roles: string[];
  dataResume: DashboardResponseDTO = new DashboardResponseDTO();
  isMapix: boolean = false;
  IsAuthenticated: boolean;
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  private config: { version: string };

  subscription_CheckAuthentication: Subscription;
  subscription_getLoading: Subscription;
  subscription_getAPIversion: Subscription;
  subscription: Subscription;

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private sessionService: SessionService
  ) {
    this.subscription_getLoading =this.dashboardService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });
  }

  ngOnInit() {
    this.config = require("src/assets/config.json");

    console.log("Version ", this.config.version);
    this.subscription_getAPIversion = this.sessionService.getAPIversion().subscribe((data) => {
      if (
        localStorage.getItem("version") == null ||
        localStorage.getItem("version") !== data
      ) {
        localStorage.setItem("version", data);
        // Las versiones no coinciden, así que recargamos la aplicación
        // location.reload();
      }
    });

    this.CheckAuthentication();
    if (this.IsAuthenticated) {
      this.isMapix = this.sessionService.isMapix;
    }
  }


  ngOnDestroy() {
    if (this.subscription_CheckAuthentication)
      this.subscription_CheckAuthentication.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    if (this.subscription_getAPIversion)
      this.subscription_getAPIversion.unsubscribe();
  }

  CheckAuthentication() {
    this.subscription_CheckAuthentication = this.authService
      .checkAuthenticated()
      .subscribe((arg) => (this.IsAuthenticated = arg));
    console.log("Authenticated:" + this.IsAuthenticated);
  }

}